import { useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { UserContext } from "../auth/UserProvider";
import { getResolverSegments, parsePathSegments } from "./Breadcrumbs";
import { useBreadcrumbData } from "./useBreadcrumbData";
const BASE_TITLE = "Log.Soccer";
/**
 * Sets document.title based on the current route's breadcrumb trail.
 *
 * For authenticated users: "Log.Soccer | <Last Breadcrumb Label>"
 * with resolved entity names (e.g. "Log.Soccer | My Team").
 *
 * For unauthenticated / home: just "Log.Soccer" or uses static
 * route config labels (e.g. "Log.Soccer | Login").
 */
export const usePageTitle = () => {
    const { user } = useContext(UserContext);
    const location = useLocation();
    const segments = parsePathSegments(location.pathname);
    const resolverSegments = getResolverSegments(segments);
    const resolvedNames = useBreadcrumbData(resolverSegments);
    useEffect(() => {
        if (location.pathname === "/") {
            document.title = BASE_TITLE;
            return;
        }
        const lastSegment = segments[segments.length - 1];
        if (!lastSegment) {
            document.title = BASE_TITLE;
            return;
        }
        let label = lastSegment.label;
        // Use resolved entity name if available
        if (lastSegment.resolver) {
            const resolved = resolvedNames[lastSegment.resolver];
            if (resolved) {
                label = resolved;
            }
        }
        // For unauthenticated users, still show static labels (Login, About Us, etc.)
        if (!user && label === "Home") {
            document.title = BASE_TITLE;
            return;
        }
        document.title = `${BASE_TITLE} | ${label}`;
    }, [location.pathname, user, segments, resolvedNames]);
};
